// Smooth scrolling for navigation links
document.querySelectorAll('nav a, .smooth-scroll').forEach(anchor => {
    anchor.addEventListener('click', function (e) {
        const href = this.getAttribute('href');
        const targetId = href.startsWith('#') ? href : null; // Check if it's an internal hash link
        const targetFile = href.includes('.html') ? href.split('#')[0] : null; // Check if it's a link to another HTML file

        // If it's an internal hash link on the *current* page
        if (targetId && !targetFile) { // Check if it starts with # and doesn't contain a file extension
            e.preventDefault(); // Prevent default navigation

            // Ensure the element exists before trying to scroll
            const targetElement = document.querySelector(targetId);
            if (targetElement) {
                targetElement.scrollIntoView({
                    behavior: 'smooth'
                });
            }
        }
    });
});